import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import ActionCreator from "../../../store/actions/index";
import { Tooltip, Polyline } from "react-leaflet";
import { typeZone } from "../../../utils/staticData";
import guid from './../../../utils/guid';
import { convertPositions, getRoutesOfType } from './../../../utils/helpers';
import t from "../../../languages/pl";
import moment from "moment-timezone";
import { displayDateTimeFormat } from './../../../utils/staticData';

const style = {
    color: "red",
    weight: 10,
    opacity: 0.3,
};

const drawPolyline = (routes) => {
    if(!Array.isArray(routes))
        routes = [routes];
    return routes.map(route => {
        return (
            <Polyline
                key={guid()}
                positions={convertPositions(route.trasa)}
                {...style}
            >
                <Tooltip
                    direction="top"
                    className="toyotaFont"
                    sticky
                >
                    {t.routeOutsideZone}
                    <br />
                    {t.timeOutsideTheZone}: {moment.unix(route.czas_poza_rejonem).format(displayDateTimeFormat)}
                    <br />
                    {t.kilometerQuantity}: {route.km_poza_rejonem}&nbsp;km
                </Tooltip>
            </Polyline>
        );
    });
};

const ZonePolyline = props => {
    const { selectedRoutes, zoneFilter } = props;
    const [visibleRoutes, setRoutes] = useState([]);

    useEffect(() => {
        if(!selectedRoutes)
            return setRoutes([]);
        let zoneRoutes = getRoutesOfType(selectedRoutes, typeZone);
        zoneRoutes = zoneRoutes.filter(zone => zone.selected === true);
        setRoutes(zoneRoutes);
        // props.fitInBounds();
    }, [selectedRoutes, zoneFilter]);

    return (
        <React.Fragment>
            {drawPolyline(visibleRoutes)}
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    return {
        selectedRoutes: state.mapRoutesReducer.selectedRoutes,
        zoneFilter: state.filterReducer.outOfZone,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};


ZonePolyline.propTypes = {
    //redux
    selectedRoutes: PropTypes.array,
    fitInBounds: PropTypes.func,
    zoneFilter: PropTypes.bool,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ZonePolyline);
